export default __webpack_public_path__ + "static/media/sibling-rivalry@2x 2.7d44d429.png";